export default {"src":"/_next/static/image/public/images/ic_shield_vertical_menu.5820a768f96d47e7ae6221f3a4a90515.svg","height":20,"width":20};